import { render, staticRenderFns } from "./AlertName.vue?vue&type=template&id=eab22366&scoped=true&"
import script from "./AlertName.vue?vue&type=script&lang=js&"
export * from "./AlertName.vue?vue&type=script&lang=js&"
import style0 from "./AlertName.vue?vue&type=style&index=0&id=eab22366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab22366",
  null
  
)

export default component.exports